import { COMPANY_TYPE } from 'src/pages/Company/Add/enums/company-type';
import { COMPANY_TYPE_ROUTE } from 'src/pages/Company/Add/enums/company-type-route';

export const companyTypeParam = {
    [COMPANY_TYPE_ROUTE.PUBLIC]: COMPANY_TYPE.PUBLIC,
    [COMPANY_TYPE_ROUTE.PRIVATE]: COMPANY_TYPE.PRIVATE,
    [COMPANY_TYPE_ROUTE.NON_PROFILE]: COMPANY_TYPE.NON_PROFILE,
};
